import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import TimeAgo from '../common/TimeAgo';
import Message from './Message.container';
import { EditedLabel, MessagesContainer } from './MessageGroup.styled';
import UserBlockContainer from './UserBlock.container';

const MessageGroup = ({
  id,
  author,
  createdAt,
  edited,
  messages,
  openEmojiPicker,
  closeEmojiPicker,
  onRepliedMessageClicked,
}) => (
  <Box id={id} data-testid="message">
    <Box display="flex" alignItems="center">
      <UserBlockContainer
        authorId={author}
        collapsed
        subtitle={<TimeAgo date={createdAt} />}
        size="small"
      />
      &nbsp;&nbsp;
      {edited && <EditedLabel>(Edited)</EditedLabel>}
    </Box>
    <MessagesContainer>
      {messages.map((messageId, index) => (
        <Message
          key={`message:${messageId}`}
          messageId={messageId}
          firstMessage={index === 0}
          openEmojiPicker={openEmojiPicker}
          closeEmojiPicker={closeEmojiPicker}
          onRepliedMessageClicked={onRepliedMessageClicked}
        />
      ))}
    </MessagesContainer>
  </Box>
);

MessageGroup.propTypes = {
  id: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  edited: PropTypes.bool.isRequired,
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
  openEmojiPicker: PropTypes.func.isRequired,
  closeEmojiPicker: PropTypes.func.isRequired,
  onRepliedMessageClicked: PropTypes.func.isRequired,
};

export default React.memo(MessageGroup);
